import styled from '@emotion/styled';
import FilterLabel from 'components/Filters/FilterLabel';
import { Text } from '@qga/roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

export const BlockText = styled(Text)`
  font-weight: inherit;
  display: block;
  :first-letter {
    text-transform: capitalize;
  }
`;

export const BlockTextBase = styled(Text)`
  font-weight: normal;
  display: block;
  :first-letter {
    text-transform: capitalize;
  }
`;

export const OpacityLabelWrapper = styled(FilterLabel)`
  opacity: 1;
  transition: opacity 0.25s ease-in-out;
  display: flex;

  &[data-disabled='true'] {
    opacity: 0.85;
  }

  ${mediaQuery.minWidth.md} {
    &:first-of-type {
      &:not(:last-of-type) {
        padding-top: 0;
      }
    }
  }

  &:last-of-type {
    border: 0;
    margin: 0;
  }
`;
